import { ResultSlots } from '../../../components/pure/components.const';

export enum TemplateSlots {
  header = 'header',
  toolbar = 'toolbar',
  leftAside = 'leftAside',
  rightAside = 'rightAside',
  body = 'body',
  footer = 'footer',
  overlay = 'overlay'
}

export enum FacetsGroupSlots {
  header = 'header',
  footer = 'footer'
}

export enum FacetSlots {
  header = 'header',
  footer = 'footer'
}

export enum DiscoveryWallSlots {
  recommendationsFallback = 'recommendationsFallback',
}

export const SLOTS = {
  template: TemplateSlots,
  discoveryWall: DiscoveryWallSlots,
  facetsGroup: FacetsGroupSlots,
  facet: FacetSlots,
  result: ResultSlots
};
